// Tiny EN / VI language pack. $t('ns.key', { param }) in templates (global property)
// or `t` in plain JS. The language is `lang` in the shared ui state (user menu,
// helpers/uiPrefs.js), so switching it re-renders every page that called $t.
// Each page owns one file in ./locales; a missing key falls back to English, then
// to the key itself. Placeholders: 'Week {week}' + { week: '12.10' }.
import { uiState } from '@/helpers/uiPrefs.js'

import common from './locales/common'
import orderHist from './locales/orderHist'
import csNote from './locales/csNote'
import inShip from './locales/inShip'
import controlPage from './locales/controlPage'
import dataLoad from './locales/dataLoad'
import login from './locales/login'
import settings from './locales/settings'
import shippingTool from './locales/shippingTool'

const PACKS = { common, orderHist, csNote, inShip, controlPage, dataLoad, login, settings, shippingTool }

export const LANGS = ['vi', 'en']

const messages = { vi: {}, en: {} }
Object.keys(PACKS).forEach(ns => {
  LANGS.forEach(lang => { messages[lang][ns] = (PACKS[ns] && PACKS[ns][lang]) || {} })
})

function lookup (lang, key) {
  return key.split('.').reduce((node, part) => (node == null ? undefined : node[part]), messages[lang])
}

export function t (key, params) {
  const lang = LANGS.includes(uiState.lang) ? uiState.lang : 'vi'
  let text = lookup(lang, key)
  if (typeof text !== 'string') text = lookup('en', key)
  if (typeof text !== 'string') return key
  if (params) {
    text = text.replace(/\{(\w+)\}/g, (match, name) => (params[name] === undefined ? match : String(params[name])))
  }
  return text
}

export default {
  install (app) {
    app.config.globalProperties.$t = t
  },
}
